import { StandardEvents } from '@shopify/events';

function updateCount(value) {
  const count = Number(value);
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-d32-cart-count]').forEach(node => { node.textContent = String(count); });
}

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (count !== undefined) updateCount(count);
  }).catch(() => {});
});

window.addEventListener('pageshow', async event => {
  if (!event.persisted) return;
  const header = document.querySelector('[data-d32-header]');
  if (!header?.dataset.cartUrl) return;
  try {
    const url = new URL(header.dataset.cartUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const response = await fetch(`${url.pathname}.js`, { credentials:'same-origin', cache:'no-store' });
    if (response.ok) updateCount((await response.json()).item_count);
  } catch (_) { /* The server-rendered bag count remains visible. */ }
});
